<template>
  <v-menu
    v-model="open"
    :content-class="contentClass"
    offset-y
    :close-on-content-click="false"
    :persistent="!true"
    allow-overflow
    v-bind="{ ...$attrs, ...positions }"
    @update:model-value="onInput"
  >
    <template #activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>
    <v-alert
      color="surface"
      border="bottom"
      :border-color="type"
      elevation="8"
      class="mb-0 pb-5"
      :class="{
        'rounded-tr-0': position === 'bottom' && align === 'right',
        'rounded-tl-0': position === 'bottom' && align === 'left',
        'rounded-br-0': position === 'top' && align === 'right',
        'rounded-bl-0': position === 'top' && align === 'left',
      }"
    >
      <slot />
      <v-alert
        v-if="$slots.error"
        :color="color"
        icon="mdi-alert"
        variant="tonal"
        class="border border-current"
      >
        <slot name="error" />
      </v-alert>
      <div class="ec-prompt-buttons mt-2">
        <v-btn
          v-if="cancelVisible && cancelAction != null"
          :color="cancelColor"
          variant="tonal"
          :disabled="!cancelEnabled"
          @click="doCancel"
        >
          {{ cancelLabel }}
        </v-btn>
        <v-btn
          v-if="submitAction !== null"
          :color="submitColor"
          type="submit"
          :loading="isSaving"
          :disabled="!submitEnabled"
          @click="doSubmit"
        >
          <v-icon v-if="!!submitIcon" start>
            {{ submitIcon }}
          </v-icon>
          {{ submitLabel }}
        </v-btn>
        <slot name="actions" />
      </div>
    </v-alert>
  </v-menu>
</template>

<script>
import DialogUiBase from '@/components/dialog/DialogUiBase.vue'

export default {
  name: 'PopoverPrompt',
  extends: DialogUiBase,
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
    align: {
      type: String,
      default: 'right',
    },
    type: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    color() {
      if (this.type === 'error') {
        return 'error'
      }

      return 'primary'
    },
    positions() {
      const positions = {}
      if (this.align === 'left') {
        positions.right = true
      } else if (this.align === 'right') {
        positions.left = true
      }
      if (this.position === 'top') {
        positions.nudgeBottom = 10
        positions.top = true
      } else if (this.position === 'bottom') {
        positions.bottom = true
      }
      return positions
    },
    contentClass() {
      return `ec-popover-prompt ec-popover-prompt--position-${this.position} ec-popover-prompt--align-${this.align}`
    },
  },
  methods: {
    setOpen(open) {
      this.open = open
    },
    async doSubmit() {
      this.isSaving = true
      await this.submitAction()
      this.isSaving = false
    },
    doCancel() {
      this.isSaving = false
      if (this.cancelAction != null) {
        this.cancelAction()
      }
      this.open = false
    },
    onInput(event) {
      // perform cancel action if dialog is dismissed without using the Cancel button
      if (event === false) {
        this.doCancel()
      }
    },
  },
}
</script>

<style scoped>
.ec-prompt-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ec-prompt-buttons .v-btn {
  flex-grow: 1;
}
</style>
